import { z } from "zod";
import { BaseAnalyticsEvent } from "./base";
export const Application_Create = BaseAnalyticsEvent.extend({
    name: z.literal("Application_Create"),
    properties: z.object({
        platform: z.string().optional()
    }).optional()
});
export const Application_Delete = BaseAnalyticsEvent.extend({
    name: z.literal("Application_Delete"),
    properties: z.object({
        platform: z.string().optional()
    }).optional()
});
